// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cc-main {
    --cc-font-family: Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    --cc-modal-border-radius: .5rem;
    --cc-btn-border-radius: .4rem;
    --cc-modal-transition-duration: .25s;
    --cc-modal-margin: 1rem;
    --cc-z-index: 2147483647;
}

/* Reject All button */
    #cc-main .cc__link, #cc-main a {
        color: #0081C9;
    }

        #cc-main .cc__link:hover, #cc-main a:hover {
            color: #61BAFF;
        }`, "",{"version":3,"sources":["webpack://./Scripts/Modules/Common/Themes/cookieconsent.theme.css"],"names":[],"mappings":"AAAA;IACI,4JAA4J;IAC5J,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA,sBAAsB;IAClB;QACI,cAAc;IAClB;;QAEI;YACI,cAAc;QAClB","sourcesContent":["#cc-main {\r\n    --cc-font-family: Inter,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";\r\n    --cc-modal-border-radius: .5rem;\r\n    --cc-btn-border-radius: .4rem;\r\n    --cc-modal-transition-duration: .25s;\r\n    --cc-modal-margin: 1rem;\r\n    --cc-z-index: 2147483647;\r\n}\r\n\r\n/* Reject All button */\r\n    #cc-main .cc__link, #cc-main a {\r\n        color: #0081C9;\r\n    }\r\n\r\n        #cc-main .cc__link:hover, #cc-main a:hover {\r\n            color: #61BAFF;\r\n        }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
